import React, { useContext, useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import ui from 'config-app/ui';
import { uiStore } from 'store/ui';
import { dataStore } from 'store/data';
import { appStore } from 'store/app';
import StepItem from './StepItem';
import useAddToCart from 'hooks/useAddToCart';
import usePreOrder from 'hooks/usePreOrder';
import useOutOfStock from 'hooks/useOutOfStock';

const Component = () => {
  const [dataState] = useContext(dataStore);
  const [appState] = useContext(appStore);
  const { customStep } = dataState;
  const [uiState] = useContext(uiStore);
  const [isAddToCart, addToCart] = useAddToCart();
  const [isAddToCartPending, setIsAddToCartPending] = useState(false);
  const addToCartTimerRef = useRef(null);
  const [isPreOrder, preOrderDates] = usePreOrder();
  const [isOutOfStock] = useOutOfStock();
  const { isPreOrderEnabled } = dataState;
  const discountRate = appState.customData.bottle.wc_discount_rate;
  const labels = window.theme


  const renderSpinner = () => {
    return (
      <div className="button isDisabled">
        <svg viewBox="0 0 20 20">
          <path
            d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z"
            fill="#919EAB"
          ></path>
        </svg>
      </div>
    );
  };

  //レイアウト調整
  const [classNames, setClassNames] = useState(``);
  let is2lines = false;
  let is3lines = false;

  //商品名の高さを取得し、2行・3行の場合はそれぞれに合わせてレイアウトを調整する
  useEffect(() => {
    var titleHeight = document.querySelector('.productName').clientHeight;
    if (titleHeight > 30 && titleHeight < 50) {
        is3lines = false;
        is2lines = true;
    } else if (titleHeight > 65) {
        is2lines = false;
        is3lines = true;
    }
    setClassNames(`${is2lines ? is3lines ? "" : "modify2lines" :  "modify3lines"}`);
  }, [appState]);

  useEffect(() => {
    return () => {
      if (addToCartTimerRef.current) {
        clearTimeout(addToCartTimerRef.current);
      }
    };
  }, []);

  const onClickAddToCart = () => {
    if (isAddToCart || isAddToCartPending || isOutOfStock) {
      return;
    }

    setIsAddToCartPending(true);
    addToCartTimerRef.current = setTimeout(() => {
      setIsAddToCartPending(false);
      addToCart();
      addToCartTimerRef.current = null;
    }, 500);
  };

  const renderCartError = () => {
    if (uiState.isErrorAddToCart) {
      return <div className="error">{uiState.errorMesageAddToCart}</div>;
    } else {
      return null;
    }
  };

  const renderPreOrderEnabledCart = () => {
    return (
      <>
        {/* 予約販売の情報表示 */}
        {isPreOrder &&
          preOrderDates.map((item, index) => (
            <div className="caution" key={index}>
              {item.product_name ? item.product_name + '（' + item.name + '）' : item.name} - {item.text}
            </div>
          ))
        }
        {isPreOrder && (<Note><p className="note">{labels.strings["preOrderNote"]}</p></Note>)}
        {/* 在庫なし商品の情報表示 */}
        {/* AjaxCart リクエスト時にスピナー表示 */}
        {isAddToCart || isAddToCartPending ? (
          renderSpinner()
        ) : isOutOfStock ? (
          <div className="button isDisabled">
            {labels.strings["soldOut"]}
          </div>
        ) : isPreOrder ? (
          <div className="button" onClick={onClickAddToCart} data-anygift="add-to-cart">
            {labels.strings["preOrder"]}
          </div>
        ) : (
          <div className="button" onClick={onClickAddToCart} data-anygift="add-to-cart">
            {labels.strings["addToCart"]}
          </div>
        )}
        {renderCartError()}
        <Shipping>
          <p>{labels.shipping_cost_note1}</p>
          <p className="shippingNote">{labels.shipping_cost_note2}</p>
        </Shipping>
      </>
    );
  };

  const renderAddCartBlock = () => {
    // 在庫なし時に予約販売対応で分岐
    if (isPreOrderEnabled) {
      return renderPreOrderEnabledCart();
    }
  };

  let isMember = false;

  if (discountRate > 0) {
    isMember = true;
  }

  return (
    <Container className={`${isMember ? "member" : ""} ${classNames}`}>
      {customStep.map((item, index) => {
        return (
          <StepItemWrapper key={index} className={item.type}>
            <StepItem
              stepId={index}
              title={item.title}
              lead={item.lead}
              variants={item.sort}
              type={item.type}
              source={item.source}
            />
          </StepItemWrapper>
        );
      })}
      <AddCart>
        {renderAddCartBlock()}
      </AddCart>
    </Container>
  );
};

export default Component;

const Container = styled.div`
  ${ui.MQ_XS_SM} {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: calc(100% - 365px);
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 30px 30px 0;
    box-shadow: 0 -4px 30px rgba(51, 51, 51, .1);
    &.member {
      height: calc(100% - 385px);
      &.modify2lines {
        height: calc(100% - 412px);
      }
      &.modify3lines {
        height: calc(100% - 439px);
      }
    }
    &.modify2lines {
      height: calc(100% - 387px);
    }
    &.modify3lines {
      height: calc(100% - 415px);
    }
    @media screen and (max-device-height: 700px) {
      height: calc(100% - 350px);
      &.member {
        height: calc(100% - 320px);
        &.modify2lines {
          height: calc(100% - 345px);
        }
        &.modify3lines {
          height: calc(100% - 375px);
        }
      }
      &.modify2lines {
        height: calc(100% - 320px);
      }
      &.modify3lines {
        height: calc(100% - 350px);
      }
    }
  }
  ${ui.MQ_MD_LG} {
    margin-top: 0;
  }
`;

const StepItemWrapper = styled.div`
  ${ui.MQ_MD_LG} {
    margin-bottom: 15px;
  }
  ${ui.MQ_XS_SM} {
    margin-bottom: 27px;
    &.bottleColor {
      margin-bottom: 15px;
    }
  }
`;

const Shipping = styled.div `
  display: inline-block;
  text-align: center;
  p {
    text-align: left;
    margin: 0;
  }
  ${ui.MQ_MD_LG} {
    margin-top: 40px;
    p {
      font-size: 16px;
    }
    .shippingNote {
      font-size: 14px;
    }
  }
  ${ui.MQ_XS_SM} {
    margin-top: 30px;
    p {
      font-size: 13px;
    }
    .shippingNote {
      font-size: 11px;
    }
  }
`


const AddCart = styled.div`
  margin-top: 20px;

  .button {
    background: #333333;
    color: #fff;
    font-weight: bold;
    text-align: center;

    &.isDisabled {
      pointer-events: none;
      background: #D7D7D7;
      color: #888888;
      &:hover {
        opacity: 1;
      }

      svg {
        width: 30px;
        height: 30px;
        animation: spin 0.5s infinite linear;
      }
    }

    @keyframes spin {
      0% {
        transform: rotate(0);
      }

      100% {
        transform: rotate(360deg);
      }
    }
  }
  .caution {  
    color: #004EA2;
    font-weight: bold;
    .note {
      font-weight: normal;
      color: #333333;
    }
  }
  ${ui.MQ_MD_LG} {
    .button {
      background: #333333;
      margin-top: 70px;
      width: 340px;
      height: 60px;
      line-height: 60px;
      transition: .3s ease;
      font-size: 18px;
      cursor: pointer;
      &:hover {
        opacity: .7;
      }
    }
    .caution {
      font-size: 18px;
    }
  }

  .error {
    margin-top: 10px;
    color: rgb(204, 0, 0);
    text-align: center;
  }
  ${ui.MQ_XS_SM} {
    .button {
      margin-top: 40px;
      height: 50px;
      line-height: 50px;
      font-size: 13px;
    }
    .caution {
      font-size: 13px;
      line-height: 26px;
    }
`;

const Note = styled.div`
  .note {
    margin: 11px 0 0;
    font-size: 12px;
  }
  ${ui.MQ_XS_SM} {
    .note {
      font-size: 10px;
    }
  }
`;
